import { SG } from "@bokio/designsystem/components/SpacingGroup/SpacingGroup";
import { BoxContent } from "@bokio/elements/Box";

import { BokioAssistantIcon } from "./BokioAssistantIcon";

import type { FC, PropsWithChildren, ReactNode } from "react";

import * as styles from "./bokioAssistantSuggestionBlock.scss";

interface BokioAssistantSuggestionBlockProps {
	isLoading: boolean;
	loadingText: ReactNode;
	text: ReactNode;
	button?: ReactNode;
	label?: ReactNode;
	/** Remove border from the box */
	noBorder?: boolean;
	/** Remove padding from the box */
	noPadding?: boolean;
}

export const BokioAssistantSuggestionBlock: FC<PropsWithChildren<BokioAssistantSuggestionBlockProps>> = props => {
	if (!props.isLoading) {
		return !!props.label ? (
			<>
				<SG horizontal align="center">
					{props.label}
				</SG>
				<SG gapInDesktop="space-between" gap="8" horizontalInDesktop padding={[!!props.button ? 12 : 4, 0, 24, 0]}>
					<SG horizontal align="center" gap="8">
						<BokioAssistantIcon />
						<div>{props.text}</div>
					</SG>
					{props.button && props.button}
				</SG>
			</>
		) : (
			<BoxContent noBorder={props.noBorder} noPadding={props.noPadding}>
				<div className={styles.wrapper}>
					<div>
						<BokioAssistantIcon />
					</div>
					<SG gap="8" gapInDesktop="space-between" horizontal align="center">
						{props.text} {props.button && props.button}
					</SG>
				</div>
				{props.children && <div className={styles.children}>{props.children}</div>}
			</BoxContent>
		);
	} else {
		return (
			<BoxContent noBorder={props.noBorder} noPadding={props.noPadding}>
				<div className={styles.wrapper}>
					<BokioAssistantIcon isLoading />
					<div>{props.loadingText}</div>
				</div>
			</BoxContent>
		);
	}
};
